import { useTranslation } from '@/features/shared/composables/useTranslation'
import { ACCOUNT_TYPE } from '@/features/shared/constants/accountType'

const t = useTranslation()

export const plansRoutes = [
  {
    path: 'plans',
    name: 'Plans',
    component: () => import('@/features/plans/views/Plans.vue'),
    meta: {
      title: `${t('plans')} | Pour Now`,
      mainRouteName: 'Plans',
      visibleAccountTypes: [ACCOUNT_TYPE.BRAND],
    },
  },
]
